<template>
  <v-dialog :value="filterForm.openModal" max-width="1000" persistent>
    <v-card class="text-center">
      <validation-observer  v-slot="{ handleSubmit }" >
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="!dataAttribute.id">Thêm mới Thuộc tính</template>
          <template v-else>Cập nhật thuộc tính</template>
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <template v-if="errorMessage">
          <v-alert type="error">{{ errorMessage }}</v-alert>
        </template>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                :rules="{
                  required: true,
                  max: 255,
                  regex: contactSettingNameRegex
                }"
                name="Mã"
              >
                <v-text-field
                  v-model="dataAttribute.name"
                  label="Mã *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                :rules="{
                  required: true,
                  max: 255,
                }"
                name="Tên"
              >
                <v-text-field
                  v-model="dataAttribute.description"
                  label="Tên *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
              <validation-provider v-slot="{ errors }" rules="required" name="Dạng dữ liệu">
                <v-autocomplete
                  v-model="dataAttribute.type"
                  :items="contactSettingTypes"
                  label="Dạng dữ liệu *"
                  :error-messages="errors"
                />
              </validation-provider>
              <v-checkbox
                v-show="dataAttribute.type === 'dropdown'"
                v-model="dataAttribute.data.multiple"
                label="Chọn nhiều"
              />
              <validation-provider 
                v-slot="{ errors }" 
                rules="required" 
                name="Danh sách tuỳ chọn"
                v-if="dataAttribute.type === 'dropdown'"
              >
                <v-text-field
                  v-show="dataAttribute.type === 'dropdown'"
                  v-model="dataAttribute.data.value"
                  label="Danh sách tuỳ chọn*"
                  color="primary"
                  :error-messages="errors"
                />
              </validation-provider>
              <p style="text-align: left; font-size: 12px;" class="primary--text"   v-show="dataAttribute.type === 'dropdown'">
                Các giá trị, được phân tách bằng ||. Ví dụ: "Đỏ||Xanh||Vàng". Các tuỳ chọn sẽ xuất hiện dưới danh sách thả xuống trong trang Khách Hàng.
              </p>
            </v-col>
            <v-col cols="12" md="12">
              <validation-provider v-slot="{ errors }" rules="required" name="Miền thuộc tính">
                <v-autocomplete
                  v-model="dataAttribute.object"
                  :items="contactSettingObjects"
                  label="Miền thuộc tính *"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveAttribute)">Lưu lại</v-btn>

          <v-btn color="primary" class="ml-0" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');
import {
  contactSettingTypes,
  contactSettingObjects,
  contactSettingNameRegex
} from '../../../helpers/constants';
export default {
  props: {
    filterForm: {
      default: () => ({})
    },
    dataAttributeOld: {
      default: () => ({})
    }
  },
  data() {
    return {
      isCreate: true,
      errorMessage: '',
      dataAttribute: {
        name: '',
        description: '',
        type: '',
        object: '',
        data: {
          multiple: false,
          value: '',
        }
      },
      contactSettingTypes,
      contactSettingObjects,
      contactSettingNameRegex
    };
  },
  created() {
    if (this.dataAttributeOld.id) {
      this.dataAttribute = {
        id: this.dataAttributeOld.id,
        name: _.get(this.dataAttributeOld, 'name', ''),
        description: _.get(this.dataAttributeOld, 'description', ''),
        type: _.get(this.dataAttributeOld, 'type', ''),
        object: _.get(this.dataAttributeOld, 'object', ''),
        data: {
          multiple: _.get(this.dataAttributeOld, 'data.multiple', false),
          value: _.get(this.dataAttributeOld, 'data.value', []).join('||'),
        }
      }
    }
  },
  methods: {
    hideModal() {
      this.filterForm.openModal = false;
    },
    async saveAttribute() {
     
      let dataUpdate = {
        name: _.trim(this.dataAttribute.name),
        description: _.trim(this.dataAttribute.description),
        type: this.dataAttribute.type,
        object: this.dataAttribute.object,
      };

      if (this.dataAttribute.type === 'dropdown') {
        dataUpdate.data = {
          multiple: _.get(this.dataAttribute, 'data.multiple', false),
          value: _.get(this.dataAttribute, 'data.value', []).split('||'),
        }
      }

      let loading = this.$loading.show();
      let response;
      let messageSuccess = 'Thêm thuộc tính mới thành công';
      if (!this.dataAttribute.id) {
        response =  await ContactRepository.createContactColumn(dataUpdate);
      } else {
        messageSuccess = 'Cập nhật thuộc tính thành công';
        response =  await ContactRepository.updateContactColumn(dataUpdate, this.dataAttribute.id);
      }
      loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }
      this.$swal({
        title: messageSuccess,
        confirmButtonText: 'Đồng ý'
      }).then(() => {
        this.hideModal();
        Bus.$emit('contact-setting-list');
      });
    },
  }
};
</script>